import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import PharmacyDashboard from 'images/Pharmacy.png';
export default function PharmacyLogInDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h4' align='center' mb={2}>{t('hospitalPharmadashboardText', { ns: ['home'] })}</Typography>
      <img src={PharmacyDashboard} style={{ width: '98vw' }} />
    </Box>
  );
}
